var Transfer = {
		transferNumAdult:null,
		transferNumChild:null,
		transferNumInfant:null,
		resultTable:$("#transferResultTable [class=item]")
};
	
var $trsMap = new Object(); 
var userLogged = false;
var isSearchFormCollapse = 0;

var  transferSearch = {
		searchAutoCompleteIdFrom:null,
		searchAutoCompleteIdTo:null,
		searchUrlFrom:null,
		searchUrlTo:null,
		fromDate:null,
		toDate:null
};


$.extend($.ui.menu.prototype.options, {
    items: "> :not(.ui-autocomplete-category)"
});

$(document).ready(function() {
	$("#transferSearchForm").validate();
	
    var pageName = $('[name="pageName"]').val();
    if(pageName){
        pageName = pageName.replace("/","");
        if( window.location.pathname.substring(1) == pageName){
            parseCookieSearchValues();
        }
    }
    datepickerGoToToday();

	var now = new Date();
	var minSearchDate = new Date();
	minSearchDate.setDate(now.getDate() + 1);

	var aYearLater = new Date(now.getFullYear()+1, now.getMonth(), now.getDate());
	$(".hasDatePickerTransferDate").datepicker({
		dateFormat : "dd.mm.yy",
		numberOfMonths : 1,
		minDate : minSearchDate,
        showButtonPanel: true,
        closeText: "x",
        maxDate : aYearLater,
		onSelect: function(dateText, inst) {
			var minDate = $.datepicker.parseDate("dd.mm.yy",dateText);
			var endDateStr = $("#returnDate").val();
			
			if(endDateStr!="")
				var endDate= $.datepicker.parseDate("dd.mm.yy",endDateStr);
			transferSearch.fromDate = dateText;
			minDate.setDate(minDate.getDate());
			$("#returnDate").datepicker("option","minDate", minDate);
			$(this).blur();
		}	
	});
	var minDate = null;
	var minDateStr = $("#transferDate").val();
	minDateStr==""?minDate = new Date():minDate = $.datepicker.parseDate("dd.mm.yy",minDateStr);
	minDate.setDate(minDate.getDate());
	var maxDate = new Date();
	maxDate.setFullYear(minDate.getFullYear()+1);
	$(".hasDatePickerReturnDate").datepicker({
		dateFormat : "dd.mm.yy",
		numberOfMonths : 1,
        showButtonPanel: true,
        closeText: "x",
        minDate : minDate,
		maxDate:maxDate,
		onSelect: function(dateText) {
			var selectedReturnDate = dateText;
			if(selectedReturnDate){
				transferSearch.toDate = selectedReturnDate;
			}
		}
		
	});
	
	
	$.widget("custom.autocomplete", $.ui.autocomplete, {
		_renderMenu : function(ul, items) {
			var that = this, currentCategory = "";
			$.each(items, function(index, item) {

				if (item.category != currentCategory) {

					if (item.category == 1) {
						ul.append("<li class='ui-autocomplete-category iconCity' >" + FmtMessage.getMessage('js.result.city')  + "</li>");
					} else if (item.category == 4 || item.category == 3) {
						ul.append("<li class='ui-autocomplete-category iconDistrict' >" + FmtMessage.getMessage('js.result.district') + "</li>");
					} else if (item.category == 2) {
						ul.append("<li class='ui-autocomplete-category iconHotel' >" + FmtMessage.getMessage('js.result.hotel') + "</li>");						
					} else if (item.category == 6) {
						ul.append("<li class='ui-autocomplete-category iconAirport' >" + FmtMessage.getMessage('js.result.airport') + "</li>");
					}

					currentCategory = item.category;
				}
				that._renderItemData(ul, item);
			});
		},
        _renderItem: function (ul, item) {
    		item.label = item.value.replace(re, "<span class='searchTerm'>$1</span>");
    		return $("<li></li>")
    			.data("item.autocomplete", item)
    			.append("<a>" + item.label + "</a>")
    			.appendTo(ul);
    		}
	});
	
	var re = null;
	$(".transferAutoComplete").click(function(){ //,#retransferFrom, #retransferTo
        var selected = $(this).data("selected");
        if(!selected){
                $(this).select();
                $(this).data("selected", true);
        }
		}).focusout(function(){
        $(this).data("selected", false);
        var value = this.value;
        var label = $(this).data("label");
        if(label != value){
                this.value = "";
                $("#" + this.id + "Id").val("");
        }
		}).autocomplete({
		source : function(request, response) {
			var otherAutoComplete = $('#' + $(this.element).data('dir')).val();
			$.ajax({
				url : "/transfer/locations",
				dataType : "json",
				data : {
					output : 'json',
					results : 100,
					query : request.term,
					otherAutoCompleteId : otherAutoComplete
				},
				success : function(data) {
					
					re = new RegExp("(" + $.ui.autocomplete.escapeRegex(request.term) + ")", "gi");
					response($.map(data, function(item) {
						return {
							value: item.name,
							category : item.type,
							id: item.id
						};
						
					}));
				}
			});
		},
		minLength : 2,
		open: function(event, ui) {
	        $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
	    },
		select : function(event, ui) {
			document.activeElement.blur();
			$(this).data("label", ui.item.value);
			$("#" + this.id + "Id").val(ui.item.id);
			$("#" + this.id + "Type").val(ui.item.category);
			
			if($(this).attr("tabindex") == 1){
				transferSearch.searchAutoCompleteIdFrom = ui.item.id;
				transferSearch.searchUrlFrom = ui.item.value;
			}
			else{
				transferSearch.searchAutoCompleteIdTo = ui.item.id;
				transferSearch.searchUrlTo = ui.item.value;
			}
		}
	    
	});	
	$.ui.autocomplete.prototype._renderItem = function (ul, item) {
		item.label = item.value.replace(re, "<span class='searchTerm'>$1</span>");
		return $("<li></li>")
			.data("item.autocomplete", item)
			.append("<a>" + item.label + "</a>")
			.appendTo(ul);
		};
	
	$("#filterCarType").change(function(){
		
		var $trs = $trsMap["car"];
		$trs.show();	
		var category = $(this).val();
		if (category != "0"){
			$trs.not("[category="+category+"]").hide();
		}else{
			$trs.show();
		}

	});
	
	$('[name="transferType"]').click(function(event) {
		if ($(this).val() == 2) {
			$('#divVehicleCat').show();
			$('#vehicleCat').prop('disabled', false);
		} else {
			$('#divVehicleCat').hide();
			$('#vehicleCat').prop('disabled', true);
		}
	});
	
	$(document).on("change","[name='direction']",function() {
		var value = $(this).val();
		if (value == "1") {
			$(".hasDatePickerReturnDate").attr("disabled", "disabled");
		} else {
			$(".hasDatePickerReturnDate").removeAttr("disabled");

		}
	});
	
	$('#roundFlag').click(function(event) {
		
		if ($(this).prop('checked')) {
			$('#returnDate').prop('disabled', false);
		} else {
			$('#returnDate').prop('disabled', true);
		}
	});
	
	$('.tablesorter').each(function (i, e) {
        var myHeaders = {};
        $(this).find('th.nosort').each(function (i, e) {
            myHeaders[$(this).index()] = { sorter: false };
        });

        $(this).tablesorter({ widthFixed: false, headers: myHeaders, textExtraction: extractPrice});
    });
	
	$(".priceDetailButton").click(function(){
		
		var transferId = $(this).attr("data-transferId");
		$("#selectedTransfer").val(transferId);
		
		var categoryId = $(this).attr("data-categoryId");
		$("#selectedTransferCategory").val(categoryId);
		
		openLoaderBox();
		$("#transferResult").submit();
		return true;
		
	});
	
	$( "#radioDirections" ).buttonset();
	
	$( ".spinnerTravelerADT" ).spinner({
		min: 1,
		max: 12
	});
	$( ".spinnerTravelerCHD" ).spinner({
		min: 0,
		max: 4
	});
	$( ".spinnerTravelerINF" ).spinner({
		min: 0,
		max: 4
	});
	
	if(Transfer.transferNumAdult){
		$('[name=numAdult]').spinner("value",Transfer.transferNumAdult);
		$('[name=numChild]').spinner("value",Transfer.transferNumChild);
		$('[name=numInfant]').spinner("value",Transfer.transferNumInfant);
	}else{
		$('#numAdult').val("1");
	}
	
	$(".spinnerTravelerADT, .spinnerTravelerCHD, .spinnerTravelerINF").change(function(){
		  var paxADT = $( "[name=numAdult]" ).spinner( "value" );
		  var paxCHD = $( "[name=numChild]" ).spinner( "value" );
		  var paxINF = $( "[name=numInfant]" ).spinner( "value" );
		  
		  	//update all search forms		  
 			$('[name=numAdult]').not(this).val(paxADT);
			$('[name=numChild]').not(this).val(paxCHD);
			$('[name=numInfant]').not(this).val(paxINF);
		  
		  
		  var totalPax = paxADT + paxCHD + paxINF;
		  $(".travelerSelectPax").html(totalPax);
		  var locale = $.cookie('siteLocale');
		  if(locale == "en"){
			  if(totalPax > 1){
			  	$(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.travelers'));
			  }else{
			  	$(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler'));
			  }
		  }else if(locale == "ru"){
			  var partLast2 = totalPax % 100;
			  var partLast1 = totalPax % 10;
			  if(partLast1 == 0 || (partLast1 >= 5 && partLast1 <= 9) || (partLast2 >= 11 && partLast2 <= 14)){
				  $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru3'));
			  }else if(partLast1 == 1){
				  $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru1'));
			  }else if(partLast1 >= 2 && partLast1 <= 4){
				  $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru2'));
			  }
		  }else{
			  $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler'));
		  }
	});
	
	$(".spinnerTravelerADT, .spinnerTravelerCHD, .spinnerTravelerINF").change();
	
	$("[name=numAdult], [name=numChild], [name=numInfant]").on("spinstop",function(){
		$(this).change();
	});		
	
	$(".travelerSelect").click(function() {
		$('.travelerList').toggle("fade","fast");
		$('.mob-modal').show();
		return false;
	});
	$('body,.classSelect').click(function(event) {
		if (!$(event.target).closest('.travelerList').length) {
			$('.travelerList').hide();
		};
	});	
	$(".classSelect").click(function() {
		$('.classList').toggle("fade","fast");
		$('.mob-modal').show();
		return false;
	});
	$('body,.travelerSelect').click(function(event) {
		if (!$(event.target).closest('.classList').length) {
			$('.classList').hide();
		};
	});	
	$(".pop-close-btn").click(function() {
		// TODO: değişiklikleri temizleyip kapatmalı
		$('.classList, .travelerList,.mob-modal').hide();
		return false;
	});
	$(".pop-btn-ok").click(function() {
		$('.classList,.travelerList,.mob-modal,.resultLeft').hide();
		return false;
	});

	$( ".transfer-filter" ).tabs();
	
	$("#showFilter").click(function() {
		$('.resultLeft').fadeToggle("fast");
		$(this).toggleClass("openFilter");
		return false;
	});
	
	$( "#radioDirections, #transferType" ).buttonset();	
	
	$("[name=transferType]").change(function(){
		var id = this.id;
		var $label = $("[for=" + id + "]");
		$(".classSelect").html($label.find("span").html());
		$('.classList,.mob-modal').hide();
	});
	var id = $("[name=transferType]:checked").attr('id');
	var $label = $("[for=" + id + "]");
	$(".classSelect").html($label.find("span").html());
	
	
	$("#clrReturnDate").click(function() {
		$(this).hide();
		$("[name='direction'][value='1']").change();
		$(".returnDate").addClass("disabled");
		transferSearch.toDate = null;
		
	});
	
	$(".summary #collapseReturnDateBox").click(function() {
		$("#clrReturnDate").show();
		$("[name='direction'][value='2']").click();
		$(".returnDate").removeClass("disabled");
		$("#returnDate").datepicker("show");
	});
	
	$("#dateToDiv > div").on("click", function() {
		$("[name='direction'][value='2']").change();
		$(".returnDate").removeClass("disabled");
		$("#returnDate").datepicker("show");
		$("#clrReturnDate").show();
	});
	
	$( ".btn-search-edit" ).on( "click", function() {
		$( this ).toggleClass("open");
		$(".summary").toggleClass("open");
		$(".search-edit-label").toggle();
	});	
	
	 $( ".btn-map" ).on( "click", function() {
 		$( "#transfer_map" ).css("height","400px");
 		$( "#routeMap" ).addClass("wide-map");
 	 	google.maps.event.trigger(map, 'resize');
 	 	displayRoute(1);
	 });	
	 $( ".btn-map-close" ).on( "click", function() {
 		$( "#transfer_map" ).css("height","250px");
 		$( "#routeMap" ).removeClass("wide-map");
 	 	google.maps.event.trigger(map, 'resize');
 	 	displayRoute(1);
	 });	
});

function extractPrice(node){
	var attribute = node.attributes["class"];
	var class1 = attribute.nodeValue;
	var text="";
	if (class1 == "infoButtons") {
	} else if (class1 == "carName") {
		text = $(node). find('td:last').html();
	} else {
		text = $(node).find("span:first").html();
	}
	
	return text;
}

function parseCookieSearchValues(){
	if($.cookie('transferSearchValues')){
		var searchData = JSON.parse($.cookie("transferSearchValues"));
		$('#fromLocationId').val(searchData.searchAutoCompleteIdFrom);
		$('#fromLocation').val(searchData.searchUrlFrom);
		
		$('#toLocationId').val(searchData.searchAutoCompleteIdTo);
		$('#toLocation').val(searchData.searchUrlTo);
		if(searchData.fromDate !=null){
			var from = $.datepicker.parseDate("dd.mm.yy", searchData.fromDate);
			$(".hasDatePickerTransferDate", document).datepicker("setDate", from);
			$(".hasDatePickerTransferDate").val(searchData.fromDate);
		}
		if(searchData.toDate != null){
			var to = $.datepicker.parseDate("dd.mm.yy", searchData.toDate);
			$(".hasDatePickerReturnDate", document).datepicker("setDate", to);
			$(".hasDatePickerReturnDate").val(searchData.toDate);
			$(".returnDate").removeClass("disabled");
			$("#clrReturnDate").show();
		}
	}
}



function moveFields () {
	
	 $('#transferDate').val($('#transferDateCollapse').val());
	 $('#returnDate').val($('#returnDateCollapse').val());
	 $('#fromLocation').val($('#fromLocationCollapse').val());
	 $('#fromLocationId').val($('#fromLocationCollapseId').val());
	 $('#toLocation').val($('#toLocationCollapse').val());
	 $('#toLocationId').val($('#toLocationCollapseId').val());
}

function submitFormCollapse() {
	 moveFields();
	 openLoaderBox();
	 document.transferSearchForm.submit();
}

function switchPoints() {

	var tempId;
	var temp;
	
	tempId = $('#fromLocationId').val();
	$('#fromLocationId').val($('#toLocationId').val());
	transferSearch.searchAutoCompleteIdFrom = $('#toLocationId').val();
	
	$('#toLocationId').val(tempId);
	transferSearch.searchAutoCompleteIdTo = $('#toLocationId').val();
	
	temp = $('#fromLocation').val();
	$('#fromLocation').val($('#toLocation').val());
	transferSearch.searchUrlFrom = $('#toLocation').val();
	$('#toLocation').val(temp);
	transferSearch.searchUrlTo = $('#toLocation').val();
}

function showList(index){
	
	$('#link-table tr').show();
	$('.show').hide();
}

function checkForSearchTransfers() {
	
	var formValid = $(document.transferSearchForm).valid();
	if(formValid) {
		openLoaderBox();
		document.transferSearchForm.submit();
	}
}

window.onbeforeunload = function (){
	var date = new Date();
	date.setTime(date.getTime() + (24 * 60 * 60 * 1000)); //24 hour
	if($.cookie('transferSearchValues')){
		var searchData = JSON.parse($.cookie("transferSearchValues"));
		if(!transferSearch.searchAutoCompleteIdFrom){
			transferSearch.searchAutoCompleteIdFrom = searchData.searchAutoCompleteIdFrom;
			transferSearch.searchUrlFrom = searchData.searchUrlFrom;
			}
		if(!transferSearch.searchAutoCompleteIdTo){
			transferSearch.searchAutoCompleteIdTo = searchData.searchAutoCompleteIdTo;
			transferSearch.searchUrlTo = searchData.searchUrlTo;
		}
		if(!transferSearch.fromDate){
			transferSearch.fromDate = searchData.fromDate;
			}
		var oneWay = $(".returnDate").hasClass("disabled");
		if(!transferSearch.toDate && !oneWay){
				transferSearch.toDate = searchData.toDate;
		}
	}
	
	if(transferSearch.searchAutoCompleteIdFrom != null){
		$.cookie('transferSearchValues',  JSON.stringify(transferSearch), { expires : date,  path : '/' });
	}
};


function datepickerGoToToday(){

    var o_gotoToday = $.datepicker._gotoToday;

    $.datepicker._gotoToday = function(id) {

        o_gotoToday.call(this, id);
        var date = new Date();
        var selDate  = this.formatDate("dd.mm.yy", date);
        this._selectDate(id, selDate);


		var hasNotReturnDate = $("#returnDate").hasClass('disabled') || isNullOrEmpty($('#returnDate').val());

		if (!hasNotReturnDate){
            $(".hasDatePickerReturnDate").datepicker("setDate", selDate);

		}

    }
}

